module.exports = __webpack_public_path__ + "img/cash.087d3831.svg";